import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import "./GoTopBtn.css";

export function GoTopBtn() {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1000) { setShowTopBtn(true); }
      else { setShowTopBtn(false); }
    });
  }, []);
  function goTop() { window.scrollTo({  top: 0,  behavior: "smooth", }); }

  return (
    <Container fluid>
      { showTopBtn && (<div className='go-top-btn' onClick={goTop}></div>) }
    </Container>
  )
}